import React, {
  forwardRef,
  useRef,
} from 'react';
import Tag from 'core/components/Tag';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import isFunction from 'lodash/isFunction';
import clsx from 'clsx';
import ToolTip from 'core/components/Tooltip';

type Parts = 'root' | 'label' | 'icon';

type Props = {
  id?: string | null;
  label?: string;
  onRemove?: (key?: string | null) => void;
  classes?: Partial<Record<Parts, string>>;
  disabled?: boolean;
  defaultColor?: string;
};

const Pill = forwardRef<HTMLDivElement, Props>(({
  id,
  label,
  onRemove,
  classes,
  disabled,
  defaultColor = 'bg-gray-200',
}, ref) => {
  const containerRef = useRef<HTMLDivElement>(null);
  return (
    <Tag
      ref={ref}
      key={id}
      className={clsx(
        'flex items-center gap-1 h-4 w-fit',
        { 'cursor-not-allowed': disabled },
        classes?.root,
      )}
      tagName={label}
      defaultColor={defaultColor}
    >
      <ToolTip title={label ?? ''} auto ref={containerRef}>
        <span ref={containerRef} className={clsx('max-w-[150px] truncate', classes?.label)}>
          {label}
        </span>
      </ToolTip>
      {isFunction(onRemove) && (
      <IconButton
        className={clsx('!p-0 !text-inherit', { '!cursor-not-allowed': disabled })}
        disabled={disabled}
        onClick={(event) => {
          event.stopPropagation();
          onRemove?.(id);
        }}
        onMouseDown={(event) => {
          event.stopPropagation();
        }}
      >
        <ClearIcon className={clsx('!w-4 !h-4 !text-inherit', classes?.icon)} />
      </IconButton>
      )}
    </Tag>
  );
});

export default Pill;
